import { PaymentFrequencyEnumOptions } from "@boundless/bl-api-client/customer/models/PaymentFrequencyEnumLabels"
import { SecurityEnumOptions } from "@boundless/bl-api-client/customer/models/SecurityEnumLabels"
import { EraserIcon, SaveIcon } from "lucide-react"
import "react-datepicker/dist/react-datepicker.css"
import { useFormContext } from "react-hook-form"

import { FormDatePicker } from "@/components/form-elements/FormDatePicker"
import { FormInput } from "@/components/form-elements/FormInput"
import { FormInputNumeric } from "@/components/form-elements/FormInputNumeric"
import { FormSelect } from "@/components/form-elements/FormSelect"
type DebtFormProps = {
  cancelEdit?: () => void
  isPending?: boolean
}

export function DebtForm({ cancelEdit, isPending = false }: DebtFormProps) {
  const form = useFormContext()
  const handleClear = () => {
    if (cancelEdit) {
      cancelEdit()
    } else {
      form.reset({
        lenderName: "",
        originalAmount: "",
        fundedDate: "",
        maturityDate: "",
        currentBalance: "",
        paymentAmount: "",
        paymentFrequency: PaymentFrequencyEnumOptions[3].value,
        security: SecurityEnumOptions[0].value,
      })
    }
  }

  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-[repeat(8,minmax(7.5rem,1fr))_5rem] lg:items-start lg:gap-2">
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Lender Name
        </p>
        <FormInput
          name="lenderName"
          placeholder="Lender Name"
          title="Lender Name"
          inputClassName="truncate"
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Original Amount
        </p>
        <FormInputNumeric
          name="originalAmount"
          placeholder="Original Amount"
          title="Original Amount"
          setValueAsString
          inputClassName="truncate"
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Funded Date
        </p>
        <FormDatePicker
          name="fundedDate"
          placeholder="Funded Date"
          maxDate={new Date()}
          className="truncate"
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Maturity Date
        </p>
        <FormDatePicker
          name="maturityDate"
          placeholder="Maturity Date"
          className="truncate"
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Current Balance
        </p>
        <FormInputNumeric
          name="currentBalance"
          placeholder="Current Balance"
          title="Current Balance"
          setValueAsString
          inputClassName="truncate"
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Payment Amount
        </p>
        <FormInputNumeric
          name="paymentAmount"
          placeholder="Payment Amount"
          title="Payment Amount"
          setValueAsString
          inputClassName="truncate"
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Payment Frequency
        </p>
        <FormSelect
          name="paymentFrequency"
          placeholder="Payment Frequency"
          hiddenLabel
          label="Payment Frequency"
          options={PaymentFrequencyEnumOptions}
        />
      </div>
      <div className="lg:py-3 lg:pr-2">
        <p className="text-muted-foreground mb-1 text-base font-medium lg:hidden">
          Security
        </p>
        <FormSelect
          name="security"
          placeholder="Security"
          hiddenLabel
          label="Security"
          options={SecurityEnumOptions}
        />
      </div>
      <div className="my-auto lg:py-3 lg:text-right">
        <div className="flex justify-start space-x-2 lg:justify-end">
          <button
            className="rounded p-1 hover:bg-gray-100"
            data-testid="save-debt-form"
            disabled={isPending}
            type="submit"
          >
            <SaveIcon className="h-5 w-5 text-gray-500" />
          </button>
          <button
            className="rounded p-1 hover:bg-gray-100"
            type="button"
            onClick={handleClear}
          >
            <EraserIcon className="text-destructive h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
